import { HttpClient } from '../HttpClient';
/**
 * * Get Recipient Lookups
 */
export const GetRecipientLookups = async (pageNumber = 1, rowsPerPage = 100) => {
  try {
    const { data } = await HttpClient.get('api/lookups/employeetypes', {
      params: {
        PageNumber: pageNumber,
        RowsPerPage: rowsPerPage,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
